$(".nav-liquid-tab").click(function() {
  $(".nav-liquid-tab").removeClass("text-primary");
  $(".nav-liquid-tab").addClass("text-dark-gray");

  if ($(this).hasClass("active")) {
    $(this).addClass("text-primary");
    $(this).removeClass("text-dark-gray");
  }
})